<template>

  <div class="p-grid p-pb-6">
		<div class="p-col-12 p-pt-1 p-pb-1">
      <h2>
        <a href="#/after-sales">{{$t('afterSales.title')}}</a> <img class="p-pl-2 p-pr-2" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/> {{ $t('afterSales.search_serial.title') }}
      </h2>

      <div class="irinox-form after-sales p-mt-4" >
        <div class="p-fluid p-formgrid p-grid p-jc-center">
              <div class="p-field p-col-12 p-md-6 p-xl-6">
                  <label for="productCode" >{{ $t('afterSales.search_serial.productCode') }}</label>
                  <InputText id="productCode" v-model="filters.productCode" :placeholder="$t('afterSales.search_serial.productCode_ph')" 
                    />
              </div>
              <div class="p-field p-col-12 p-md-6 p-xl-6">
                  <label for="serialNumber" >{{ $t('afterSales.search_serial.serialNumber') }}</label>
                  <InputText id="serialNumber" v-model="filters.serialNumber" :placeholder="$t('afterSales.search_serial.serialNumber_ph')" 
                    />
              </div>
              <div class="p-col-12 p-d-flex p-ai-center p-jc-center p-mt-3 p-mb-6" style="gap: 10px;">
                  <Button :label="$t('afterSales.search_serial.btn_search')" class="" @click="() => { if(filters.productCode || filters.serialNumber) { searchProducts() } }" style="width: fit-content;"/>
                  <Button :label="$t('afterSales.search_serial.btn_reset')" class="p-button-outlined" @click="resetFilters" style="width: fit-content;"/>
              </div>
          </div>
          
          <div v-if="submitted">
            <DataTable :value="products" stripedRows 
                class="after-sales-table-full"
                responsiveLayout="stack" 
                breakpoint="960px" 
                :autoLayout="true" v-model:sortField="table.orderAttr" v-model:sortOrder="table.ascOrDesc"
                :paginator="true" paginatorPosition="bottom" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink" 
                v-model:first="table.first" :rows="table.rows" :totalRecords="table.totalRecords" :lazy="true"
                @update:first="searchProducts" selectionMode="single" v-model:selection="selectedProduct" @rowSelect="onRowSelect"
                :currentPageReportTemplate="'{totalRecords} ' + $t('afterSales.search_document.counter')">

                <Column field="numeroMatricola" :header="$t('afterSales.search_serial.col_numeroMatricola')" sortable ></Column>
                <Column field="codice" :header="$t('afterSales.search_serial.col_codice')" sortable ></Column>
                <Column field="descrizione" :header="$t('afterSales.search_serial.col_descrizione')" sortable></Column>
                <!-- <Column field="descrizioneArticoloAggiuntiva" :header="$t('afterSales.search_serial.col_descrizioneArticoloAggiuntiva')"></Column> -->
                <Column field="divisione" :header="$t('afterSales.search_serial.col_divisione')" sortable></Column>
                <Column field="descrizioneClasseMerceologica" :header="$t('afterSales.search_serial.col_descrizioneClasseMerceologica')" sortable></Column>

            </DataTable>
          </div>
      </div>



    </div>
  </div>

  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('afterSales.search_serial.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />

</template>

<script>
import { mapGetters } from 'vuex';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import AfterSalesService from '../../service/AfterSalesService';

export default {
  components: { 
    IrinoxDialogDark,
  },
  data() {
    return {
      filters: { 
        productCode: null, 
        serialNumber: null,
      },
      submitted: false,
      dialog: {
        error: false,
      },
      products: [],
      table: {
        rows: 50,
        totalRecords: 0,
        first: 0,
        orderAttr: 'numeroMatricola',
        ascOrDesc: 1,
      },
      selectedProduct: null,
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      docTreeRaw: 'afterSales/docTreeRaw',
      searchSerial: 'afterSales/searchSerial',
      role: 'userdata/role',
    }),
  },
  watch: {
  },
  created() {
    this.afterSalesService = new AfterSalesService();
  },
  mounted() { 
    this.filters.productCode = this.searchSerial?.productCode;
    this.filters.serialNumber = this.searchSerial?.serialNumber;
    if(this.filters.productCode || this.filters.serialNumber) {
      this.searchProducts();
    }
  },
  unmounted() {
    this.$store.commit('afterSales/searchSerial', {productCode: this.filters.productCode, serialNumber: this.filters.serialNumber});
  },
  methods: {
    resetFilters() {
      this.filters = { 
        productCode: null, 
        serialNumber: null,
      };
      this.products = [];
      this.selectedProduct = null;
      this.table.totalRecords = 0;
      this.table.first = 0;
      this.table.orderAttr = 'numeroMatricola';
      this.table.ascOrDesc = 1;
      this.submitted = false;
    },
    searchProducts() {
      this.products = [];
      this.table.totalRecords = 0;
      this.table.first = 0;
      this.submitted = true;
      this.afterSalesService.postDocsRmSearch(this.personaltoken, this.filters, this.table, this.$functions.language(this.$i18n.locale))
        .then((data) => {
          if(data.code=="200") {
            this.products = data.body.items;
            this.table.totalRecords = data.body.count;
          } else {
            console.error(JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("ERROR "+error);
          this.dialog.error = true;
        });
    },
    onRowSelect(what) {
      console.log("selected product", what);
      this.$router.push({ name: 'after-sales-search-serial-bom', params: { serialNumber: this.selectedProduct.numeroMatricola, productCode: this.selectedProduct.codice } });
    }
  },
}
</script>